// 録音時プリセット。ユーザーが録音開始時に選ぶ生成方針 (yakureki-back log/166)。
//   auto = 標準  : 会話が短い回だけ過去履歴を参照。モデルは設定の is_quick_mode に従う
//   deep = 深掘り: 常に過去履歴を参照し、賢いモデルで生成
// 値はそのまま back の history_policy として送る (preset === history_policy)。
// 実際の注入判定・model tier の解決はすべてサーバ側の責務。
export type RecordingPreset = 'auto' | 'deep'

export const DEFAULT_RECORDING_PRESET: RecordingPreset = 'auto'
